import React, {Component} from 'react';
import './Provider.css';
import IndustryIndividualMoreCard from '../../../Components/IndustryIndividualMoreCard/IndustryIndividualMoreCard.js'
import providerCover from '../../../../../images/individual/agriculture/AgriCover.jpg';
import providerSolution from '../../../../../images/individual/medical/ProviderSolution.png';
import providerShortage from '../../../../../images/individual/medical/ProviderShortage.jpg';
import providerProjection from '../../../../../images/individual/medical/ProviderProjection.png';

export default class provider extends Component {
	render() {
		return (
			<div className="provider_container">
				<div className="objective_title">HEALTHCARE PROVIDER</div>
				<hr className="objective_break"/>
				<div className="objective_subtitle">In 2019, PPI invested into Aries Healthcare Group in the United Kingdom to offer as the leading healthcare solution provider and operators to build and own exceptional care habitats to meet the increasing demand in the 2nd Tier City such as Manchester and Liverpool in the United Kingdom.</div>
				<div className="provider_content">
					<IndustryIndividualMoreCard
						image={providerSolution}
						title= 'THE BUSINESS SOLUTION: NICHE MARKET'
						description1='Aries Healthcare Group realizes the opportunity of a niche market to supply healthcare facilities to the mass market with acute demand for Elderly & Mentally Infirm Plus Care (EMI PLUS) for people living in the community of St. Helens. Highly subsidized National Insurance schemes extensively funded by the government are provided to the local community. '
						description2='Aries Group shall complete our 1st Prototype Project and start healthcare business operation by end 2020.'
					/>
					<IndustryIndividualMoreCard
						image={providerShortage}
						title='ACUTE SHORTAGE OF HEALTHCARE CENTERS'
						description1='We aim to bring high quality, but affordable services to be within the reach of local community. In entire UK, as well as St Helens Borough, there are substantial shortage of healthcare centers, with the local patients being turned away and sent to far away places.'
					/>
					<IndustryIndividualMoreCard
						image={providerProjection}
						title='5 YEAR PROJECTION PLAN'
						description1='PPI shall further support in the Investment of Aries Group for the next 5 Year Projection Plan to expand more healthcare centre in the United Kingdom to service the British people, and spread a wider network. Once their presence is well rooted in UK, Aries shall further plan for overseas expansion to  Asia Pacific Region.'
					/>
				</div>
			</div>
		);
	}
}
